import { connect } from 'react-redux';
import { actions } from '../../../../../redux/modules/biblioteca/archivos';
import SubirArchivos from './SubirArchivos';


const ms2p = (state) => {
    return {
        ...state.archivos,
        form: state.form.ArchivosForm
    };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(SubirArchivos);
